export default "__VITE_ASSET__C$nfOB3E__"